import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 26a2 2 0 0 1-1.995-1.85L2 24v-3.101c0-.895.593-1.673 1.438-1.919l.334-.08a3.001 3.001 0 0 0 .001-5.8l-.334-.08a2 2 0 0 1-1.432-1.752L2 11.1V8a2 2 0 0 1 1.85-1.995L4 6h24a2 2 0 0 1 1.994 1.85L30 8v3.101c0 .895-.593 1.673-1.438 1.919l-.334.08a3.001 3.001 0 0 0-.001 5.8l.334.08c.793.23 1.364.929 1.432 1.753l.007.166V24a2 2 0 0 1-1.85 1.994L28 26zm7-18H4v3.1l.223.051a5 5 0 0 1 0 9.698l-.224.051L4 24h7zm17 0H13v16h15v-3.1a5.001 5.001 0 0 1-.224-9.75l.223-.051z"
    />
  </svg>
);
const SvgIconRebates = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconRebates);
export default Memo;
